var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filtters"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.77738 20C8.43097 20 8.1406 19.8802 7.90627 19.6406C7.67193 19.401 7.55476 19.1042 7.55476 18.75V11.25L0.249618 1.71875C-0.0356597 1.36458 -0.0764137 0.989583 0.127356 0.59375C0.331126 0.197917 0.646969 0 1.07489 0H18.9251C19.353 0 19.6689 0.197917 19.8726 0.59375C20.0764 0.989583 20.0357 1.36458 19.7504 1.71875L12.4452 11.25V18.75C12.4452 19.1042 12.3281 19.401 12.0937 19.6406C11.8594 19.8802 11.569 20 11.2226 20H8.77738ZM10 11.375L17.3357 1.875H2.66429L10 11.375Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.6a4f35c7982bb6bf804fefd86e16ad4a.svg";
export { ForwardRef as ReactComponent };